import axios from '@axios'

export default {
  namespaced: true,
  state: {
    notificationList:[],
    intervalNotifications: null
  },
  getters: {
    notificationsLength: (state) => {
      return state.notificationList.length;
    }
  },
  mutations: {
    UPDATE_NOTIFICATIONS(state, new_notifications) {
      console.log("Notifications updated", new_notifications);
      state.notificationList = new_notifications;
    },
    SET_INTERVAL(state, intervalId) {
      state.intervalNotifications = intervalId;
    },
    CLEAR_INTERVAL(state) {
      state.intervalNotifications = null;
    }
  },
  actions: {
    update({state, commit, rootGetters} ) {
      const company = rootGetters['workspace/getCompany'];
      console.log("Fetching notifications for company", company);
      if (!company || !company.company) {
        return;
      }
      const url = `${process.env.VUE_APP_URL}/api/v1/account/notifications/?company=${company.company}`;

      return axios.get(url).then((res) => {
        
        commit("UPDATE_NOTIFICATIONS", res.data);
      });
    },
    markAsRead({ state, commit }, { context, notification }) {
      const url = `${process.env.VUE_APP_URL}/api/v1/account/notifications/${notification.id}/`;

      return context.$http.put(url, { is_read:true });
    },

    startPullingNotifications({state, commit, dispatch}) {
      // Clear any existing interval first
      if (state.intervalNotifications) {
        clearInterval(state.intervalNotifications);
      }
      
      const intervalId = setInterval(() => {
        dispatch("update");
      }, 30000);
      
      commit('SET_INTERVAL', intervalId);
    },

    stopPullingNotifications({state, commit}) {
      if (state.intervalNotifications) {
        clearInterval(state.intervalNotifications);
        commit('CLEAR_INTERVAL');
      }
    }
  }
}
